export default "__VITE_ASSET__DC78d96l__"